export const LINKS = {
  instagramDM: "https://ig.me/m/nexfoldconsults",
  instagram:
    "https://www.instagram.com/nexfoldconsults?igsh=MW4wMjNlc3d1ZWRjMg==",
  email: "info@nexfoldconsults.com",
};

export const NAV_ITEMS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = {
  flagship: {
    tag: "Flagship",
    title: "Business Setup & End-to-End Support",
    description:
      "We help entrepreneurs transform business ideas into structured, legally compliant, and growth-ready ventures through comprehensive end-to-end consultancy.",
    items: [
      "Business Registration",
      "Company Formation",
      "Business Planning",
      "Compliance Guidance",
      "Brand Positioning",
      "Operational Setup",
      "Marketing Strategy",
      "Business Growth Roadmaps",
      "Ongoing Advisory Support",
    ],
  },
  career: {
    tag: "Career",
    title: "Career Guidance",
    description:
      "Helping students and professionals position themselves for better career opportunities with personalised guidance and practical strategies.",
    items: [
      "Career Planning",
      "LinkedIn Profile Optimisation",
      "Interview Preparation",
      "Job Search Strategy",
      "Personal Branding",
      "Networking Support",
    ],
  },
};

export const WHY = [
  {
    title: "Personalised Consultancy",
    body: "Every journey is different. Our advice is tailored around your goals.",
  },
  {
    title: "Strategic Thinking",
    body: "We focus on long-term outcomes rather than quick fixes.",
  },
  {
    title: "End-to-End Support",
    body: "From planning to execution, we stay with you throughout the process.",
  },
  {
    title: "Transparency",
    body: "Clear communication and practical recommendations at every stage.",
  },
  {
    title: "Professional Excellence",
    body: "Quality, integrity, and trust are at the heart of every consultation.",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Understand Your Journey",
    body: "Every consultation begins with a conversation. We listen to your ambitions, context, and constraints before advising anything.",
  },
  {
    step: "02",
    title: "Build The Strategy",
    body: "We translate your goals into a clear, practical plan — whether that's a career move or a compliant, growth-ready business.",
  },
  {
    step: "03",
    title: "Execute Together",
    body: "From registration to interviews, we stay hands-on, guiding each decision so nothing stalls or gets lost in complexity.",
  },
  {
    step: "04",
    title: "Grow With Confidence",
    body: "As you progress, we provide ongoing advisory support to help you scale, adapt, and keep moving forward.",
  },
];

export const FAQS = [
  {
    q: "Who does Nexfold work with?",
    a: "We work with students, professionals, aspiring entrepreneurs, and established business owners — anyone navigating an important career or business decision in the UK and beyond.",
  },
  {
    q: "What does 'end-to-end business support' actually include?",
    a: "From business registration and company formation to planning, compliance, brand positioning, operational setup, marketing strategy, and ongoing advisory — we support you across the entire lifecycle of building your venture.",
  },
  {
    q: "How do consultations begin?",
    a: "Every engagement starts with understanding your journey. We take time to learn your goals before recommending anything, because the best solutions are always personalised.",
  },
  {
    q: "How do I book a consultation?",
    a: "Simply tap any 'Book a Consultation' button on this page. It opens a direct message with our team on Instagram, where we'll take it from there.",
  },
  {
    q: "Do you only support UK-based clients?",
    a: "While Nexfold is UK-based, our guidance is international in outlook. We regularly support ambitious individuals building careers and businesses across borders.",
  },
];
